import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, resolveComponent as _resolveComponent } from "vue"

import {computed} from 'vue';
import OperatorApplicationSwitchConfig from "~/operatorApplication/vue/config/OperatorApplicationSwitchConfig.vue";
import InlineSelect from "~/core-ui/vue/ui/InlineSelect.vue";
import {__} from "~/ts/library/Translate";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import NonFreeConfigOption from "~/operatorApplication/vue/config/NonFreeConfigOption.vue";
import OperatorApplicationServerSideConfigInterface
    from "~/operatorApplication/ts/service/OperatorApplicationServerSideConfigInterface";
import getBuddyListDisplayConfigItems from "~/operatorApplication/ts/service/getBuddyListDisplayConfigItems";
import ServerSideConfigUsedWarning from "~/operatorApplication/vue/config/ServerSideConfigUsedWarning.vue";


const __default__ = {
    name: "OperatorApplicationConfigBuddyList"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    configuration: {},
    isServerSide: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;


let buddyListDisplayConfigItems = computed(() => {
    return getBuddyListDisplayConfigItems(props.configuration);
});

let autoClearBuddyListDelay = computed(() => {
    let result = [];
    for (let i of [1, 2, 3, 4, 6, 9, 12, 24, 48, 72]) {
        result.push({value: i * 60 * 60, label: __("через %d ч.", i)});
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isServerSide)
      ? (_openBlock(), _createBlock(ServerSideConfigUsedWarning, {
          key: 0,
          class: "mb-4"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, { "label-position": "top" }, {
      default: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(_unref(__)("Список контактов")), 1),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: __props.configuration.autoClearBuddyListEnabled,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.configuration.autoClearBuddyListEnabled) = $event)),
          disabled: __props.isServerSide
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Автоматически удалять неактивные чаты из списка')) + " ", 1),
            (__props.configuration.autoClearBuddyListEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(InlineSelect, {
                    modelValue: __props.configuration.autoClearBuddyListDelay,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.configuration.autoClearBuddyListDelay) = $event)),
                    disabled: __props.isServerSide,
                    options: _unref(autoClearBuddyListDelay).map(item => ({ value: item.value, label: item.label }))
                  }, null, 8, ["modelValue", "disabled", "options"]),
                  _createVNode(NonFreeConfigOption, { class: "ml-1" }),
                  _createVNode(HelpBlock, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(__)("Необработанные Offline-вопросы не будут удаляться автоматически.")), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(NonFreeConfigOption, { key: 1 }))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: __props.configuration.autoClearClosedDialogsBuddyListEnabled,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.configuration.autoClearClosedDialogsBuddyListEnabled) = $event)),
          disabled: __props.isServerSide
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Автоматически удалять завершённые диалоги из списка')) + " ", 1),
            _createVNode(NonFreeConfigOption)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: __props.configuration.showYouInDialogForOfflineNotification,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.configuration.showYouInDialogForOfflineNotification) = $event)),
          disabled: __props.isServerSide
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Показывать пометку "%s" для Offline-вопросов', _unref(__)("Вы участвовали в этом диалоге"))), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(OperatorApplicationSwitchConfig, {
          modelValue: __props.configuration.confirmOnRemoveFromBuddyList,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.configuration.confirmOnRemoveFromBuddyList) = $event)),
          disabled: __props.isServerSide
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Запрашивать подтверждение при удалении клиента из списка')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createElementVNode("h2", null, _toDisplayString(_unref(__)("Внешний вид")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buddyListDisplayConfigItems), (item) => {
          return (_openBlock(), _createBlock(OperatorApplicationSwitchConfig, {
            disabled: __props.isServerSide,
            key: item.descr,
            "model-value": item.getter(),
            "onUpdate:modelValue": ($event: any) => (item.setter($event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.descr), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "model-value", "onUpdate:modelValue"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})